// src/components/JourneyCTA.js

import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';
import AnimatedCounter from '../components/AnimatedCounter'; // Make sure path is correct
import './css/JourneyCTA.css';

const JourneyCTA = () => {
  return (
    <section className="journey-cta-section">
      <Container className="journey-cta-container">
        <div className="journey-cta-card">
          {/* Background Glow Effects */}
          <div className="journey-cta-glow journey-cta-glow-right" />
          <div className="journey-cta-glow journey-cta-glow-left" />

          {/* Main Content */}
          <h2 className="journey-cta-title">
            Ready to Book Your
            <br />
            Next <span>Big Audition?</span>
          </h2>

          <p className="journey-cta-description">
            Join thousands of actors and casting directors who are changing the
            industry one audition at a time.
          </p>

          {/* Stats / Counters */}
          <Row className="g-3 text-center justify-content-center journey-cta-stats">
            <Col md={4} xs={4}>
              <div className="journey-stat-number">
                <AnimatedCounter endValue={50000} duration={2000} />+
              </div>
              <div className="journey-stat-label">Active Talent</div>
            </Col>
            <Col md={4} xs={4}>
              <div className="journey-stat-number">
                <AnimatedCounter endValue={5000} duration={2000} />+
              </div>
              <div className="journey-stat-label">Casting Pros</div>
            </Col>
            <Col md={4} xs={4}>
              <div className="journey-stat-number">
                <AnimatedCounter endValue={100000} duration={2000} />+
              </div>
              <div className="journey-stat-label">Auditions</div>
            </Col>
          </Row>

          {/* CTA Button */}
          <div className="journey-cta-actions">
            <Link to="/register" className="journey-cta-btn journey-cta-btn-primary">
              Create Profile
            </Link>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default JourneyCTA;